var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PtDialog",
    {
      attrs: {
        "append-to-body": "",
        "custom-class": "case-time-dialog",
        "data-important-master": "case-time-dialog",
        width: "800px",
        top: "64px",
        modal: false,
        visible: _vm.showDialog,
        title: _vm.$t("case_time.title"),
        beforeClose: _vm.beforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.showDialog = $event
        },
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "link case-time-dialog__close-btn",
          on: {
            click: function ($event) {
              return _vm.Hidden()
            },
          },
        },
        [
          _vm._v(" " + _vm._s(_vm.$t("case_time.close")) + " "),
          _c("PtIcon", {
            staticStyle: { "font-size": "20px", fill: "#1976d2" },
            attrs: { icon: "SolidArrowUp" },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "base-loading",
              rawName: "v-base-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _vm.tempShowMsg
            ? _c(
                "p",
                {
                  staticClass: "case-time-dialog__warning-tip",
                  attrs: { "data-msg-type": _vm.tempShowMsgType },
                },
                [_vm._v(_vm._s(_vm.tempShowMsg))]
              )
            : _vm._e(),
          _c(
            "base-form",
            {
              ref: "formRef",
              attrs: {
                "label-position": "top",
                "label-width": _vm.LabelWidth,
                size: "small",
                model: _vm.form,
                rules: _vm.Rules,
              },
            },
            [
              _c(
                "base-form-item",
                { attrs: { prop: "title", label: _vm.$t("case_time.name") } },
                [
                  _c("base-autocomplete", {
                    attrs: {
                      "popper-class": "case-time__autocomplete",
                      disabled: !_vm.FormEnabeld,
                      placeholder: _vm.$t("case_time.project_name_placeholder"),
                      "fetch-suggestions": _vm.queryCaseTimeTitles,
                    },
                    on: {
                      select: _vm.onSelectProject,
                      blur: _vm.onTitleInputBlur,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "case-time__autocomplete_item_inner",
                                attrs: {
                                  "data-activate":
                                    _vm.form.title === item.title,
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.title))]),
                                _c("PtIcon", {
                                  staticStyle: {
                                    "font-size": "24px",
                                    fill: "#45A321",
                                  },
                                  attrs: { icon: "SolidTick" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "base-form-item",
                {
                  attrs: {
                    prop: "description",
                    label: _vm.$t("case_time.description"),
                  },
                },
                [
                  _c("base-input", {
                    attrs: {
                      type: "textarea",
                      disabled: !_vm.FormEnabeld,
                      placeholder: _vm.$t("case_time.description_placeholder"),
                      rows: 7,
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "description",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
              _vm.showDialog ? _c("CaseTimeClock") : _vm._e(),
              _vm._v(" "),
              _c("footer", { staticClass: "case-time-dialog__actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "link",
                    attrs: {
                      target: "_blank",
                      href: _vm.context.CaseTimeDetailUrl,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("case_time.view_my_case")) + " ")]
                ),
                _c(
                  "div",
                  { staticClass: "case-time-dialog__actions_btngroup" },
                  [
                    _vm.ButtonsShow.Start
                      ? _c("CaseTimeButton", {
                          attrs: {
                            type: _vm.E_Buttons.Start,
                            disabled: !_vm.ButtonsEnabled.Start,
                          },
                          on: { click: _vm.onClickStart },
                        })
                      : _vm._e(),
                    _vm.ButtonsShow.Pause
                      ? _c("CaseTimeButton", {
                          attrs: {
                            type: _vm.E_Buttons.Pause,
                            disabled: !_vm.ButtonsEnabled.Pause,
                          },
                          on: { click: _vm.onClickPause },
                        })
                      : _vm._e(),
                    _vm.ButtonsShow.Restart
                      ? _c("CaseTimeButton", {
                          attrs: {
                            type: _vm.E_Buttons.Restart,
                            disabled: !_vm.ButtonsEnabled.Restart,
                          },
                          on: { click: _vm.onClickRestart },
                        })
                      : _vm._e(),
                    _c("CaseTimeButton", {
                      attrs: {
                        type: _vm.E_Buttons.End,
                        disabled: !_vm.ButtonsEnabled.End,
                      },
                      on: { click: _vm.onClickEnd },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }